<script>
  import { Circle2 } from "svelte-loading-spinners";
  import { createEventDispatcher } from "svelte";
  import axios from "axios";
  import config from "../stores/config";
  import * as ls from "local-storage";
  import Modal from "../shared/Modal.svelte";
  import Select from "svelte-select";

  export let _id;
  export let addedOn;
  export let agent;
  export let amount;
  export let currency;
  export let reason;
  export let category;

  const numberWithCommas = (x) => {
    return x?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  };

  const removeDays = (date, days) => {
    var result = new Date(date);
    result.setDate(result.getDate() - days);
    return result.toISOString().slice(0, 10);
  };

  const addDays = (date, days) => {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result.toISOString().slice(0, 10);
  };

  const getHM = (date) => {
    date = new Date(date);
    let moment = date.toISOString().slice(0, 10);

    if (moment == new Date().toISOString().slice(0, 10)) {
      moment = "aujourd'hui";
    } else if (addDays(moment, 1) == new Date().toISOString().slice(0, 10)) {
      moment = "hier";
    } else {
      moment = new Date(date).toDateString();
    }
    return `${moment} à ${date.getHours()}:${date.getMinutes()}`;
  };

  const dispatch = createEventDispatcher();

  const handleDelete = () => {
    let confirmDelete = confirm("Voulez-vous supprimer");

    if (confirmDelete) {
      axios
        .delete(`${$config.backendURL}/txs/${_id}`, {
          headers: { authorization: ls.get("jwt") },
        })
        .then((res) => {
          dispatch("delete");
        })
        .catch((err) => {
          console.log(err);
          alert(err);
        });
    }
  };

  // Update A New Pledger-------------------------------------------------------------------
  let editedTx = {
    addedOn,
    agent,
    amount,
    currency,
    reason,
    category,
  };

  let showEditTxForm = false;
  let updatingTx = false;

  const handleUpdate = (e) => {
    updatingTx = true;
    axios
      .put(
        `${$config.backendURL}/txs/${_id}`,
        {
          ...editedTx,
          category: editedTx.category.value,
          currency: editedTx.currency.value,
        },
        { headers: { authorization: ls.get("jwt") } }
      )
      .then((res) => {
        showEditTxForm = false;
        updatingTx = false;
        dispatch("update");
      })
      .catch((err) => {
        updatingTx = false;
        console.log(err);
        alert(err);
      });
  };
</script>

<Modal
  show={showEditTxForm}
  on:modalClose={() => {
    showEditTxForm = false;
  }}
>
  <div class="grid gap-y-2">
    <input
      bind:value={editedTx.agent}
      type="text"
      placeholder="Agent/Companie"
      required
    />

    <Select
      items={["ENTREE", "SORTIE"]}
      bind:selectedValue={editedTx.category}
      placeholder="Entrée ou Sortie"
    />

    <input bind:value={editedTx.amount} type="number" placeholder="Montant" />

    <Select
      items={["DOLLARS", "FRANCS"]}
      bind:selectedValue={editedTx.currency}
      placeholder="Devise"
    />

    <input
      bind:value={editedTx.reason}
      type="text"
      placeholder="Raison"
      required
    />

    {#if updatingTx}
      <div class="grid grid-cols-1 gap-8">
        <div class="btn btn-primary">
          <Circle2
            size="25"
            unit="px"
            colorOuter="#F4A261"
            colorCenter="#40B3FF"
            colorInner="#676778"
          />
          <span class="ml-4">Veuillez Patienter...</span>
        </div>
      </div>
    {:else}
      <!-- else content here -->
      <div class="flex">
        <button
          style="width: 100%;"
          class="btn btn-primary"
          on:click={handleUpdate}
        >
          <ion-icon name="checkmark-circle" class="text-2xl mr-3" />
          Sauver
        </button>
        <button
          style="width: 100%;"
          class="ml-4 btn btn-secondary"
          on:click={(e) => (showEditTxForm = false)}
        >
          <ion-icon name="close-circle" class="text-2xl mr-3" />
          Fermer
        </button>
      </div>
    {/if}
  </div>
</Modal>

<!--  -->
<!--  -->
<div
  class="px-2 pt-2 pb-1 rounded-md shadow-sm bg-gradient-to-r from-gray-50 to-gray-100 border border-gray-200"
>
  <div class="">
    <h1
      class="tracking-wider uppercase text-green-600 flex items-center justify-between mb-2"
    >
      <div class="flex items-center">
        <h1
          class="tracking-wider uppercase mr-2 text-xs py-1 px-2 rounded-md shadow-sm text-gray-100"
          class:bg-blue-400={category == "ENTREE"}
          class:bg-red-400={category == "SORTIE"}
        >
          {category}
        </h1>
        — {numberWithCommas(amount)}
        {currency == "DOLLARS" ? "$" : "Fc"}
      </div>
      <div class="flex items-center">
        <button
          on:click={handleDelete}
          class="ml-1 text-red-400 text-sm flex items-center justify-center rounded-lg py-1 px-2 bg-white shadow-sm"
        >
          <ion-icon name="trash-bin" />
        </button>
        <button
          on:click={(e) => (showEditTxForm = true)}
          class="ml-1 text-blue-400 text-sm flex items-center justify-center rounded-lg py-1 px-2 bg-white shadow-sm"
        >
          <ion-icon name="pencil" />
        </button>
        <button
          on:click={(e) => {
            config.update((prev) => ({
              ...prev,
              full: !$config.full,
            }));
          }}
          class="ml-1 text-gray-600 text-sm flex items-center justify-center rounded-lg py-1 px-2 bg-white shadow-sm"
        >
          <ion-icon name="remove" />
        </button>
      </div>
    </h1>

    {#if $config.full}
      <div class="pb-1">
        <div class="flex justify-between">
          <div class="text-sm flex items-center">
            <ion-icon name="calendar" class="text-xl mr-2" />
            {getHM(addedOn)} par
            <span class="text-blue-500 ml-1 font-bold">{agent}</span>
          </div>
        </div>

        <div class="mt-2 text-sm text-gray-400">
          {reason}.
        </div>
      </div>
    {/if}
  </div>
</div>
